module.exports = __webpack_public_path__ + "img/nathan-bedford-forrest.1cf62c38.png";